import { useMemo } from "react";
import type { TaskPerformanceMetricRow } from "@/lib/task-metrics";
import { TaskMemberMetricsBarChart } from "@/components/tasks/TaskMemberMetricsBarChart";
import { TaskPerformanceMemberAreaChart } from "@/components/tasks/TaskPerformanceMemberAreaChart";

interface TaskPerformanceMemberChartProps {
  workspaceId: string;
  from: string;
  to: string;
  rows: TaskPerformanceMetricRow[];
  members?: { id: string; display_name: string | null }[];
  loading?: boolean;
  projectId?: string | null;
}

export function TaskPerformanceMemberChart({
  workspaceId,
  from,
  to,
  rows,
  members = [],
  loading,
  projectId = null,
}: TaskPerformanceMemberChartProps) {
  const memberNames = useMemo(() => {
    if (members.length > 0) {
      return members.map((m) => ({
        id: m.id,
        name: m.display_name ?? "Sem nome",
      }));
    }
    return rows.map((r) => ({
      id: r.member_id,
      name: r.display_name ?? "Sem nome",
    }));
  }, [members, rows]);

  const barData = useMemo(
    () =>
      [...rows]
        .sort((a, b) => b.completed - a.completed)
        .map((r) => ({
          name: r.display_name ?? "Sem nome",
          completed: r.completed,
          positive: r.positive_count,
          negative: r.negative_count,
          overdue: r.overdue,
        })),
    [rows],
  );

  return (
    <div className="space-y-4">
      <TaskPerformanceMemberAreaChart
        workspaceId={workspaceId}
        from={from}
        to={to}
        memberNames={memberNames}
        loading={loading}
        projectId={projectId}
      />
      <TaskMemberMetricsBarChart
        data={barData}
        title="Resumo por membro"
        loading={loading}
        showBorder
      />
    </div>
  );
}
